import React from "react";
import { Form } from "react-bootstrap";
import UploadIcon from "../../../Assets/svg/upload-icon.svg";

const Screen1 = ({
  dragging,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  inputref,
  handleInputChange,
  selectedFiles,
}) => {
  return (
    <div className="flex-grow-1 d-flex flex-column">
      <h5 className="text-center fw-bold m-0">Upload Supporting Files</h5>
      <div className="browsefile d-flex mt-4">
        <Form.Control
          disabled
          type="text"
          placeholder={
            selectedFiles ? selectedFiles?.name : "Choose files to upload"
          }
          className="custominput bg-white"
        />
        <button
          className="btn btn-primary customradius px-4"
          type="button"
          disabled={selectedFiles}
          onClick={() => inputref.current.click()}
        >
          Browse Files
        </button>
        <input
          type="file"
          onChange={handleInputChange}
          ref={inputref}
          className="d-none"
          accept=".csv"
        />
      </div>
      <hr style={{ color: "#C5C5D3" }} />
      <div className="flex-grow-1">
        <div
          className={`dropcontainer ${dragging ? "bg-success text-white" : ""}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <img src={UploadIcon} width={75} height={65} alt="upload-icon" />
          <h4 className="fw-bold m-0 text_gray">
            {dragging ? "Dropping..." : "Drag and drop here"}
          </h4>
        </div>
      </div>
    </div>
  );
};

export default Screen1;
